import request from '@/plugins/ecommerce_axios'
import request_admin from '@/plugins/admin_axios'

export const CreateCartApi = async (cartData) => {
  const response = await request.post('/carrinho/create/', cartData, { headers: { 'Content-Type': 'application/json' } })
  return response.data
}

export const GetShoppingCartApi = async (uuid, env = 'ecommerce') => {
  var response
  if (env === 'admin') {
    response = await request_admin.get(`/carrinho/get/?uuid=${uuid}`)
  }else{
    response = await request.get(`/carrinho/get/?uuid=${uuid}`)
  }
  return response.data
}

export async function CheckModuloVideoByCarrinho(uuid_carrinho, env = 'ecommerce') {
  try{
    var response
    if (env === 'admin') {
      response = await request_admin.get(`/carrinho/modulo-video-active/${uuid_carrinho}`)
    }else{
      response = await request.get(`/carrinho/modulo-video-active/${uuid_carrinho}`)
    }
    if (response.status != 200) {
      return false
    }

    const data = response.data.data
    return data?.is_video_active || false
  } catch {
    return false
  }
}

export const ListAllShoppingCartByUserApi = async (data_inicio, data_fim, user_uuid, affiliate_code = null, search_value = null, page = 1, page_size = 10) => {
  // Tratamento básico para valores nulos na string
  const search = search_value ? search_value : ''
  const affiliate = affiliate_code ? affiliate_code : ''

  const response = await request.get(`/carrinho/list/minhas-compras/?data_inicio=${data_inicio}&data_fim=${data_fim}&user_uuid=${user_uuid}&affiliate_code=${affiliate}&search_value=${search}&page=${page}&page_size=${page_size}`)
  return response.data
}

export const ListAllMyIndicationsByAffiliateApi = async (data_inicio, data_fim, user_uuid, search_value = null, page = 1, page_size = 10) => {
  const search = search_value ? search_value : ''

  const response = await request.get(`/carrinho/list/minhas-indicacoes/?data_inicio=${data_inicio}&data_fim=${data_fim}&user_uuid=${user_uuid}&search_value=${search}&page=${page}&page_size=${page_size}`)
  return response.data
}

export const ValidateItemChangeApi = async (data) => {
  console.log(data);
  return await request_admin.post('/carrinho/validar-troca-item/', data);
}

export const ItemChangeApi = async (data) => {
  return await request_admin.post('/carrinho/alterar-item-carrinho/', data);
}

export const ApplyCupomApi = async (data) => {
  try {
    const response = await request.post('/cupom/apply/', data);
    return response.data
  } catch (error) {
    if (error.response) {
      // Retorna o erro que veio do backend
      return error.response.data
    } else {
      // Retorna erro genérico
      return {
        status: 'error',
        message: 'Erro inesperado. Tente novamente mais tarde.',
        data: null
      };
    }
  }
}

export const ListSolicitantes = async (search = null, limit = null) => {
  let params = ''

  if (search) {
    params += `?search=${search}`
  }

  if (limit) {
    if (params.length > 0) {
      params += '&'
    } else {
      params += '?'
    }
    params += `limit=${limit}`
  }

  const response = await request_admin.get(`/user/list/${params}`);
  return response.data
}

/**
 *
 * @param {string} uuid
 * @param {{ observacao: string }} payload
 * @returns
 */
export const CancelShoppingCart = async (uuid, payload) => {
  const response = await request_admin.post(`/carrinho/cancel/${uuid}`, payload)
  return response.data
}

export const ValidateBillingDocument = async (data) => {
  const response = await request_admin.post(`/carrinho/validate_billing_document/`, data)
  return response.data
}

export const UpdateFaturamentoApi = async (data) => {
  const response = await request_admin.put('/carrinho/update/faturamento/', data)
  return response.data
}

export const GetShoppingCartLogsApi = async (uuid) => {
  const response = await request_admin.get(`/carrinho/logs/${uuid}`)
  return response.data
}

export const ValidarModificacaoItemApi = async (data) => {
  return await request_admin.post('/carrinho/item/validar-modificacao/', data)
}

export const AdicionarItemCarrinhoApi = async (data) => {
  return await request_admin.post('/carrinho/item/adicionar/', data)
}

export const AtualizarQuantidadeItemApi = async (data) => {
  return await request_admin.put('/carrinho/item/atualizar-quantidade/', data)
}

export const RemoverItemCarrinhoApi = async (data) => {
  return await request_admin.delete('/carrinho/item/remover/', { data })
}
